"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isBillingPlanSlug = exports.BILLING_PLAN_SLUGS = exports.BillingPlanSlug = void 0;
var BillingPlanSlug;
(function (BillingPlanSlug) {
    BillingPlanSlug["FREE"] = "free";
    BillingPlanSlug["ORGANIC"] = "organic";
    BillingPlanSlug["FOUNDERS_CLUB"] = "founders-club";
    BillingPlanSlug["AGENCY"] = "agency";
    BillingPlanSlug["STANDARD"] = "standard";
})(BillingPlanSlug || (exports.BillingPlanSlug = BillingPlanSlug = {}));
exports.BILLING_PLAN_SLUGS = Object.values(BillingPlanSlug);
const isBillingPlanSlug = (slug) => exports.BILLING_PLAN_SLUGS.includes(slug);
exports.isBillingPlanSlug = isBillingPlanSlug;
